import { ImgixImage } from '@components/gassan-ui/Image/ImgixImage'
import { Spinner } from '@gassan-ui'
import { cn } from '@lib/cn'
import { FC } from 'react'
import { useLifestyleHover } from './hooks/use-lifestyle-hover'

type Props = {
  src: string
  alt: string
}

const LifestyleHover: FC<Props> = ({ src, alt }) => {
  const { status, handleImageOnLoad } = useLifestyleHover()

  return (
    <>
      <div
        className={cn(
          'absolute bottom-0 left-0 z-[3] h-full w-full scale-[1.03] bg-white bg-gradient-to-b from-transparent to-black/75 opacity-100 transition-[opacity,transform] duration-100 ease-linear',
          status === 'image-loaded' && 'scale-100 opacity-100',
        )}
        data-is-image-loaded={status === 'image-loaded' ? '' : undefined}
      >
        <ImgixImage src={src} alt={alt} className="absolute inset-0" onLoad={handleImageOnLoad} />
      </div>
      {status === 'is-loading-slow' && (
        <div className="absolute left-0 top-0 z-[3] flex h-full w-full items-center justify-center">
          <Spinner />
        </div>
      )}
      <span className="absolute bottom-0 left-0 z-[3] block h-1/2 w-full animate-[fadeInGradient_0.1s_linear_forwards] bg-gradient-to-b from-transparent to-black/75 opacity-100" />
    </>
  )
}

export default LifestyleHover
